import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../ModalTrigger';
import ReferralOptions from '../../ReferralsIndexContainer/ReferralOptions';
import { putRequest } from '../../../requestUtils';
import logoImg from '../../../../assets/images/Logo_Gray.svg';
import './ConfirmSubmitProposal.scss';
var ConfirmSubmitProposal = /*#__PURE__*/function (_Component) {
  function ConfirmSubmitProposal(props) {
    var _this;
    _classCallCheck(this, ConfirmSubmitProposal);
    _this = _callSuper(this, ConfirmSubmitProposal, [props]);
    _this.state = {
      fullName: props.fullName,
      currentStep: props.fullName ? 1 : 0,
      error: null,
      isSubmitted: false,
      ProposalDetails: {}
    };
    _this.handleUpdateName = _this.handleUpdateName.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _inherits(ConfirmSubmitProposal, _Component);
  return _createClass(ConfirmSubmitProposal, [{
    key: "handleChange",
    value: function handleChange(event) {
      var fullName = event.target.value;
      this.setState({
        fullName: fullName
      });
    }
  }, {
    key: "handleUpdateName",
    value: function handleUpdateName() {
      var _this2 = this;
      var _this$props = this.props,
        updateUserSettingsUrl = _this$props.updateUserSettingsUrl,
        csrfToken = _this$props.csrfToken;
      var fullName = this.state.fullName;
      if (fullName) {
        putRequest(updateUserSettingsUrl, {
          user: {
            full_name: fullName
          }
        }, csrfToken).then(function () {
          _this2.setState({
            error: null,
            currentStep: 1,
            isSubmitted: false
          });
        });
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this3 = this;
      var _this$props2 = this.props,
        formUrl = _this$props2.formUrl,
        csrfToken = _this$props2.csrfToken;
      return putRequest(formUrl, {}, csrfToken).then(function (_ref) {
        var data = _ref.data;
        _this3.setState({
          error: null,
          currentStep: 2,
          isSubmitted: true,
          proposalDetails: data
        });
      })["catch"](function (err) {
        _this3.setState({
          error: err.error
        });
      });
    }
  }, {
    key: "renderStep",
    value: function renderStep() {
      var _this4 = this;
      var _this$props3 = this.props,
        csrfToken = _this$props3.csrfToken,
        submitToOpenMarketplace = _this$props3.submitToOpenMarketplace,
        referralProps = _this$props3.referralProps;
      var _this$state = this.state,
        fullName = _this$state.fullName,
        currentStep = _this$state.currentStep,
        error = _this$state.error;
      if (currentStep === 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "text-center"
        }, /*#__PURE__*/React.createElement("img", {
          src: logoImg,
          alt: "Clora",
          className: "logo"
        }), /*#__PURE__*/React.createElement("h1", {
          className: "mb-2 medium-weight"
        }, "Please add your name before submitting"), /*#__PURE__*/React.createElement("form", {
          id: "update-full-name",
          onSubmit: function onSubmit(event) {
            return event.preventDefault();
          }
        }, /*#__PURE__*/React.createElement("input", {
          type: "text",
          id: "full_name",
          className: "form-control fs-hide mt-3  mb-3 ",
          placeholder: "Full Name",
          name: "user[full_name]",
          value: fullName,
          onChange: function onChange(event) {
            return _this4.handleChange(event);
          },
          required: true
        }), /*#__PURE__*/React.createElement("button", {
          id: "update-name-button",
          className: "btn btn-primary mb-45",
          onClick: function onClick() {
            return _this4.handleUpdateName();
          }
        }, "Add Name")));
      }
      if (currentStep === 1) {
        return /*#__PURE__*/React.createElement("div", {
          className: "text-center"
        }, /*#__PURE__*/React.createElement("img", {
          src: logoImg,
          alt: "Clora",
          className: "logo"
        }), /*#__PURE__*/React.createElement("h1", {
          className: "mb-2 medium-weight"
        }, "You are about to submit your proposal"), /*#__PURE__*/React.createElement("div", {
          className: "flex-center"
        }, submitToOpenMarketplace && /*#__PURE__*/React.createElement("div", {
          className: "body-text-2"
        }, "Your proposal will be sent directly to the hiring manager. If accepted, Clora will coordinate the interview. Check your proposal's status under My Applications."), !submitToOpenMarketplace && /*#__PURE__*/React.createElement("div", {
          className: "body-text-2"
        }, "Clora will review your proposal and reach out to you shortly. You can also check your proposal's status under My Applications.")), error && /*#__PURE__*/React.createElement("div", {
          className: "alert alert-danger"
        }, error));
      }
      return /*#__PURE__*/React.createElement(ReferralOptions, _extends({}, referralProps, {
        csrfToken: csrfToken,
        location: "Proposal Submission",
        heroCopy: "Proposal Successfully Submitted!",
        referredUserType: "consultant"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        triggerText = _this$props4.triggerText,
        animation = _this$props4.animation,
        disabled = _this$props4.disabled,
        buttonStyles = _this$props4.buttonStyles,
        handleProposalAfterSubmit = _this$props4.handleProposalAfterSubmit;
      var _this$state2 = this.state,
        currentStep = _this$state2.currentStep,
        proposalDetails = _this$state2.proposalDetails;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: triggerText,
        disabled: disabled,
        cancelButtonText: "No, Cancel",
        submitButtonText: "Yes, Submit",
        buttonStyles: buttonStyles,
        handleSubmit: this.handleSubmit,
        idKey: "confirm-submit-proposal-modal",
        animation: animation,
        showFooter: currentStep === 1,
        onCloseCallback: function onCloseCallback() {
          return handleProposalAfterSubmit(proposalDetails);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "confirm-submit-proposal style-guide"
      }, this.renderStep()));
    }
  }]);
}(Component);
ConfirmSubmitProposal.propTypes = {
  fullName: PropTypes.string,
  updateUserSettingsUrl: PropTypes.string.isRequired,
  triggerText: PropTypes.string,
  formUrl: PropTypes.string.isRequired,
  submitToOpenMarketplace: PropTypes.bool,
  csrfToken: PropTypes.string.isRequired,
  animation: PropTypes.bool,
  disabled: PropTypes.bool,
  referralProps: PropTypes.shape({
    shareOnLinkedinUrl: PropTypes.string.isRequired,
    referralPath: PropTypes.string.isRequired,
    newReferralPath: PropTypes.string.isRequired,
    authCodeUrl: PropTypes.string.isRequired
  }).isRequired,
  buttonStyles: PropTypes.string,
  handleProposalAfterSubmit: PropTypes.func
};
ConfirmSubmitProposal.defaultProps = {
  fullName: null,
  submitToOpenMarketplace: false,
  triggerText: 'Submit Proposal',
  animation: true,
  disabled: false,
  buttonStyles: 'primary',
  handleProposalAfterSubmit: function handleProposalAfterSubmit() {}
};
export default ConfirmSubmitProposal;